function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M82.8598 51.76L34.2998 23.73V79.8L82.8598 51.76ZM82.8598 51.76L34.2998 23.73V79.8L82.8598 51.76Z",
  stroke: "white",
  strokeWidth: 0.85,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.7599 103.1C80.1142 103.1 103.1 80.1143 103.1 51.76C103.1 23.4057 80.1142 0.420044 51.7599 0.420044C23.4056 0.420044 0.419922 23.4057 0.419922 51.76C0.419922 80.1143 23.4056 103.1 51.7599 103.1Z",
  stroke: "white",
  strokeWidth: 0.85,
  strokeMiterlimit: 10
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null);
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/play-button.9d9431a8.svg";
export { ForwardRef as ReactComponent };